import { render } from "./ProductsView.vue?vue&type=template&id=5b2021a8&scoped=true&ts=true"
import script from "./ProductsView.vue?vue&type=script&lang=ts"
export * from "./ProductsView.vue?vue&type=script&lang=ts"

import "./ProductsView.vue?vue&type=style&index=0&id=5b2021a8&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2021a8"]])

export default __exports__